import { useStore } from 'react-redux';

import { useUser } from '../../../hooks/useUser';
import { getV2025Steps } from '../utils/stepperUtils';
import { DetailingStep } from '../../../components/registering/utils/registerEnums';
import { RegistrationCommonStep } from '../../../utils/navigation';

export const useRegistrationSteps = (currentStep: DetailingStep | RegistrationCommonStep) => {
  const store = useStore();
  const { user } = useUser();
  const userInput = store.getState().register.userInput;

  const steps = getV2025Steps(user, userInput.detaljeringssteg || []);
  const currentStepIndex = steps.findIndex((step) => step === currentStep);

  const nextStep = steps[currentStepIndex + 1];
  const previousStep = steps[currentStepIndex - 1];

  return { nextStep, previousStep, steps, currentStepIndex };
};
